import GameState from "slotworks/model/game-state";
import { Connector } from "slotworks/server/connectors/connector";
import { SocketConnector } from "slotworks/server/connectors/socket-connector";

class AGSSocketConnector extends SocketConnector implements Connector {

    protected resolveRequest(message: any) {

        const errorResponse = JSON.parse(message.data) as AGSErrorResponseSchema;

        if (errorResponse.error !== undefined) {
            const fatal = !this.isInsufficientFundsError(errorResponse.error);
            this.errorSignal.dispatch(errorResponse.error.message, fatal);

            if (!fatal) {
                super.resolveRequest(null);
            }
        } else {
            super.resolveRequest(message);

            if (GameState.getCurrentGame().hasRecords()) {
                const gameComplete = GameState.getCurrentGame().isComplete();
                gameWrapper.balancesUpdate(
                    GameState.getCurrentGame().realBalance,
                    GameState.getCurrentGame().freeBalance,
                    gameComplete ? GameState.getCurrentGame().getTotalWin() : 0
                );
            }
        }
    }

    private isInsufficientFundsError(error: AGSError) {
        if (error.code.toString() === "1003") {
            gameWrapper.insufficientFunds();
        }
        return error.code.toString() === "1003";
    }
}

export interface AGSErrorResponseSchema {
    error: AGSError;
}

export interface AGSError {
    code: number;
    message: string;
}

export default new AGSSocketConnector();
